<!-- Lots of customizations - check instead if original file has changed between versions and otherwise keep this one as it is. -->
<div class="page-header top-header" *ngIf="visible">
  
  <nav class="navbar navbar-expand-lg navbar-expand-md navbar-light bg-white top-navbar py-0 head-lg-screen" [class.mega-menu]="canViewHeader">

    <div class="collapse navbar-collapse" id="navbarText">
      <div class="container-fluid">
        <div class="row">
          <div class="col-auto" [style.minWidth.px]="100">
            <!--<ul class="navbar-nav">
              <li class="nav-item"><a class="nav-link " href="https://www.fagerhult.com/About-Fagerhult/">About</a></li>
              <li class="nav-item"><a class="nav-link " href="https://www.fagerhult.com/Contact/">Contact</a></li>
              <li class="nav-item"><a class="nav-link " href="http://www.fagerhultgroup.com" target="_blank">Investor Relations</a></li>
            </ul>-->
          </div>
          <div class="col align-middle justify-content-center">            
            <a class="navbar-brand mr-0" routerLinkActive="active" href="#/" (click)="navigate('')">
              <co-image type="svg" imageSet="" [width]="'340px'" key="logo"></co-image>
            </a>
          </div>
          <div class="col-auto align-middle justify-content-center" [style.minWidth.px]="100" >
            <ul class="navbar-nav justify-content-end" *ngIf="canViewHeader" >
              <li class="nav-item"><a class="nav-link"  href="#/logout" (click)="navigate('logout')" >Logout </a></li>              
            </ul>
          </div>
        </div>
      </div>

    </div>

  </nav>

  <nav class="navbar navbar-expand-lg navbar-expand-md navbar-light bg-white navbar-main mega-menu p-0 head-sm-screen #topHeader">
    
    <div class="row w-100 mx-0">
      <!--<div class="col-auto" [style.width.px]="70" >
      </div>-->
      <div class="col align-middle">
        <a class="navbar-brand mr-0 d-lg-none d-md-none" [style.width.px]="260" routerLinkActive="active" href="#/" (click)="navigate('')">
          <co-image type="svg" imageSet="" [width]="'340px'" key="logo"></co-image>
        </a>
      </div>
      <div class="col-auto align-middle justify-content-center" [style.width.px]="70" >
        <div *ngIf="showSecondLogo" class="px-2 px-md-4 mr-0 mr-md-3 align-middle second-logo-sm" style.maxWidth="calc(100% - 100px - {{maxWidth}})">
    <co-image [type]="logoTypeSecondLogo" class="logo" [style.maxWidth]="maxWidthSecondLogo" [imageSet]="imageSetSecondLogo" key="logo2"></co-image>
  </div>
        <button *ngIf="canViewHeader" class="navbar-toggler navbar-toggler-right collapsed mr-2" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" #navbarToggler>
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar top-bar"></span>
          <span class="icon-bar middle-bar"></span>
          <span class="icon-bar bottom-bar"></span>
        </button>
      </div>
    </div>

      <div *ngIf="canViewHeader" class="collapse navbar-collapse" id="navbarSupportedContent" #navbarSupportedContent>
        <ul class="navbar-nav h-100">
          <ng-container *ngFor="let link of links">
            <li *ngIf="link.routerLink != 'logout'" class="nav-item" routerLinkActive="{{link.routerLinkActive}}">
              <a class="nav-link " href="#/{{link.routerLink}}" (click)="navigate(link.routerLink)">{{link.text}}</a>
            </li>
          </ng-container>
          <li class="nav-item d-none d-sm-block d-md-none">
            <a class="nav-link " href="#/logout" (click)="navigate('logout')">Logout</a>
          </li>          
        </ul>
      </div>
  <div *ngIf="showSecondLogo" class="px-2 px-md-4 mr-0 mr-md-3 ml-2 ml-md-3 align-middle second-logo">
    <co-image [type]="logoTypeSecondLogo" class="logo" [style.maxWidth]="maxWidthSecondLogo" [imageSet]="imageSetSecondLogo" key="logo2"></co-image>
  </div>
</nav>
</div>
